<template>
  <div>
    <b-card no-body>
      <b-card-header class="pb-50 d-flex justify-content-between align-items-center">
        <h4 class="mb-0">
          <i class="fa-solid fa-heart-pulse text-primary"></i>
          {{ $t('monitoring.title') }}
        </h4>
        <b-button variant="outline-primary" size="sm" @click="refresh">
          <i class="fa-solid fa-arrows-rotate"></i> {{ $t('operations.refresh') }}
        </b-button>
      </b-card-header>
      <b-card-body>
        <div v-if="loading" class="text-center py-4">
          <b-spinner />
        </div>
        <div v-else-if="healthChecks.length === 0" class="text-center py-4 text-muted">
          No organizations with health check URLs configured.
        </div>
        <b-table v-else :items="healthChecks" :fields="fields" striped hover responsive show-empty>
          <template #cell(up)="data">
            <b-badge :variant="data.value ? 'success' : 'danger'" class="px-2 py-1">
              <i :class="data.value ? 'fa-solid fa-circle-check' : 'fa-solid fa-circle-xmark'"></i>
              {{ data.value ? 'UP' : 'DOWN' }}
            </b-badge>
          </template>
          <template #cell(statusCode)="data">
            <b-badge :variant="getStatusVariant(data.value)">
              {{ data.value || 'N/A' }}
            </b-badge>
          </template>
          <template #cell(checkedAt)="data">
            {{ formatDate(data.value) }}
          </template>
          <template #cell(errorMessage)="data">
            <span v-if="data.value" class="text-danger">{{ data.value }}</span>
            <span v-else class="text-muted">-</span>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import mixinBase from '@/components/mixin/mixinBase'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinNotifications from '@/components/mixin/mixinNotifications'

export default {
  name: 'MonitoringView',
  mixins: [mixinBase, mixinPermissions, mixinNotifications],
  data() {
    return {
      loading: false,
      healthChecks: [],
      fields: [
        { key: 'orgName', label: 'Organization', sortable: true },
        { key: 'url', label: 'URL', sortable: false },
        { key: 'up', label: 'Status', sortable: true },
        { key: 'statusCode', label: 'HTTP Code', sortable: true },
        { key: 'errorMessage', label: 'Error', sortable: false },
        { key: 'checkedAt', label: 'Last Check', sortable: true },
      ],
      refreshInterval: null,
    }
  },
  created() {
    this.refresh()
    this.refreshInterval = setInterval(() => this.refresh(), 60000)
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    ...mapActions('monitoring', ['getHealthStatus']),
    refresh() {
      this.loading = true
      this.getHealthStatus()
        .then(data => {
          this.healthChecks = data || []
        })
        .catch(err => {
          this.showErrorNotification('Health Check', 'Failed to load health status')
        })
        .finally(() => {
          this.loading = false
        })
    },
    getStatusVariant(code) {
      if (!code || code === 0) return 'secondary'
      if (code >= 200 && code < 300) return 'success'
      if (code >= 300 && code < 400) return 'info'
      if (code >= 400 && code < 500) return 'warning'
      return 'danger'
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString()
    },
  },
}
</script>
